module.exports = __webpack_public_path__ + "static/media/active-users.5173b581.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/active-users.svg
// module id = 1412
// module chunks = 0